module.exports = __webpack_public_path__ + "./images/tier3.jpg";